<template>
  <ul class="flex overflow-x-auto custom-scrollbar horizontal">
    <li
      v-for="(tab, index) in tabs"
      @click="onTabClick(tab)"
      class="flex items-center px-4 py-2 lg:px-5 lg:py-3 whitespace-nowrap text-sm rounded-tr-md rounded-tl-md cursor-pointer hover:bg-white transition-colors hover:text-cardinal"
      :class="{
        'bg-neutral-800 dark:bg-cardinal dark:text-cardinal-50 text-white': modelValue == tab.key,
      }"
    >
      <slot :name="`${tab.key}-tab`" :tab="tab">
        {{ tab.label }}
      </slot>
    </li>
  </ul>
</template>
<script lang="ts" setup>
type Tab = { key: string; label: string };
type CmpProps = {
  tabs?: Array<Tab>;
  modelValue?: string;
  scrollToTop?: boolean;
};
const props = withDefaults(defineProps<CmpProps>(), {
  scrollToTop: false,
});
const emit = defineEmits(['update:modelValue']);
const onTabClick = (tab: Tab) => {
  if (props.scrollToTop && import.meta.client && typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }
  emit('update:modelValue', tab.key);
};
</script>
